import { Configuration } from "@azure/msal-browser";

const redirectUri: string = window.location.protocol + "//" + window.location.host;

export const authConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_APPID || "",
    authority: process.env.REACT_APP_AUTHORITY || "",
    redirectUri: redirectUri
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false
  }
};

export const loginRequest = {
  scopes: (process.env.REACT_APP_SCOPES || "").split(",")
};

export interface SilentRequest {
  scopes: string[];
  loginHint: string;
}

export const silentRequest = (account: string): SilentRequest => ({
  scopes: (process.env.REACT_APP_SCOPES || "").split(","),
  loginHint: account
});
